export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-04.4001cdd7.svg";